"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

exports.LineBox = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", "px;\n    padding-left: ", "px;\n    padding-right: ", "px;\n"], ["\n    width: ", "px;\n    padding-left: ", "px;\n    padding-right: ", "px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.paddingLeft;
}, function (props) {
  return props.paddingRight;
});
exports.HLine = styled_components_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n    height: 1px;\n    width: 100%;\n"], ["\n    background: ", ";\n    height: 1px;\n    width: 100%;\n"])), function (props) {
  return props.theme.colors.gray;
});
var templateObject_1, templateObject_2;